import { VIEWS } from '../../constants';

const { NARROW, BROAD, ALL } = VIEWS;

export function filterVisibleEntries(entries) {
  return entries.filter(({ isActive }) => isActive);
}

export function filterFocusAndVisibleEntries(entries) {
  const entriesToFilter = entries.filter((entry) => {
    return entry.inFocus;
  });
  return filterVisibleEntries(entriesToFilter);
}

export function getCompetitorTypeAndVisibilityFilter(view) {
  return (entries) => {
    const entriesToFilter = entries.filter((entry) => {
      switch (view) {
        case ALL:
          return true;
        case BROAD:
          return entry.competitorType === BROAD || entry.competitorType === NARROW;
        default:
          return entry.competitorType === view;
      }
    });
    return filterVisibleEntries(entriesToFilter);
  };
}

export function getAverages(domainEntries) {
  const totalDto = domainEntries.reduce(
    (acc, entry) => {
      acc.score += entry.powerrank.score;
      acc.rankSum += entry.rankSum;
      acc.prevRankSum += entry.prevRankSum;
      return acc;
    },
    { score: 0, rankSum: 0, prevRankSum: 0 },
  );
  return {
    score: round(totalDto.score / domainEntries.length),
    trend: round((100 * (totalDto.rankSum - totalDto.prevRankSum)) / totalDto.rankSum, 2),
  };
}

function round(value, precession = 0) {
  const multiplier = Math.pow(10, precession);
  return Math.round(value * multiplier) / multiplier;
}
